import React from 'react'
import { Skeleton } from 'is24-corecss'
import { useTranslation } from 'react-i18next'
import { RentPriceCheckLabel } from '../rent-price-check-label/RentPriceCheckLabel'
import styles from './RentPriceCheckSkeleton.module.css'

export function RentPriceCheckSkeleton() {
  const { t } = useTranslation()

  return (
    <section
      className={styles.card}
      role='status'
      aria-busy='true'
      aria-label={t('wizard.screen.basicInfo.price.recommendedNotification.loading')}
      data-testid='rent-price-check-skeleton'
    >
      <RentPriceCheckLabel />

      <div className={styles.title}>
        <Skeleton type='rounded' width='46%' height='24px' />
        <Skeleton type='rounded' width='74%' height='24px' />
      </div>

      <div className={styles.chart}>
        <Skeleton type='rounded' width='100%' height='112px' />
      </div>

      <div className={styles.footer}>
        <Skeleton type='rounded' width='32%' height='24px' />
      </div>
    </section>
  )
}
